/**
 * Darf „Daten befüllen" in der Firmen-Anlage starten?
 *
 * Mit einem Namen (mindestens drei Zeichen) sucht der Server die Website.
 * Steht eine Website — oder eine E-Mail, deren Domain er laden kann — in der
 * Maske, liest er das Impressum direkt; der Name ist dann nicht nötig und kommt
 * samt Rechtsform aus dem Impressum (T-323).
 */
export function befuellenMoeglich(e: { name?: unknown; website?: unknown; email?: unknown }): boolean {
    const text = (v: unknown) => String(v ?? "").trim();
    if (text(e.name).length >= 3) return true;
    if (text(e.website).includes(".")) return true;
    const mail = text(e.email);
    return mail.includes("@") && mail.split("@").pop()!.includes(".");
}
